import { useCommunity } from "@amityco/ui-kit-open-source";
import { useEffect } from "react";

export default function GetCommunity({communityId , onReady }) {
    const bbvrGlobalCommunity = useCommunity(communityId);
    
    useEffect(() => {
        if (!bbvrGlobalCommunity)
        {
            return;
        }
        
        if (!bbvrGlobalCommunity.isJoined)
        {
            bbvrGlobalCommunity.join().catch(console.error);
        }
        
        if (onReady)
        {
            onReady(bbvrGlobalCommunity);
        }
    }, [bbvrGlobalCommunity, onReady]);
    
    return null;
  }